import { ReactNode } from 'react';
import s from './Container.module.scss';

interface ContainerProps {
	children: ReactNode;
	className?: string;
}

export const Container = ({ children, className }: ContainerProps) => (
	<div className={`${s.container} ${className}`}>{children}</div>
);
